// https://github.com/chakra-ui/chakra-ui-docs/blob/main/src/components/omni-search.tsx
// export const getIsMac = () =>
//   /(Mac|iPhone|iPod|iPad)/i.test(navigator?.platform)

export const getIsMac = () =>
  (navigator?.userAgentData?.platform || navigator?.platform || 'unknown')
    .toLowerCase()
    .includes('mac')
